module.exports = __webpack_public_path__ + "static/img/p4_6.7119f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p4_6.png
// module id = rhP1
// module chunks = 0